
























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class ListReceipt extends Vue {
    @Prop({ default: () => [] })
    private listReceipt!: any[];

    private viewDetail(receipt: any) {
        if (!receipt || !receipt.id) {
            return;
        }
        this.$router.push({ name: 'receipt-detail', params: { id: receipt.id.toString() } });
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }
}
